import languageOptions from 'components/SystemLangs/languageOptions';
import { useCallback } from 'react';
import { useTranslate } from '@tolgee/react';

export function useGetTaskName() {
  const { t } = useTranslate();

  const getTaskName = useCallback(
    ({ isDefault, name }: Pick<Aide.Pause.Task, 'isDefault' | 'name'>) => {
      if (!isDefault) {
        return name;
      }

      const defaultNames = languageOptions.map(({ value }) =>
        t('pause_auto_reply', { lng: value }),
      );

      return defaultNames.includes(name) ? t('pause_auto_reply') : name;
    },
    [t],
  );

  return {
    t,
    getTaskName,
  };
}
